var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiComparison',{attrs:{"products":_vm.productsData,"i18n":_vm.i18n,"locator-btn-data":_vm.locatorBtnData,"empty-state-data":_vm.emptyStateData}})}
var staticRenderFns = []

export { render, staticRenderFns }